import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { withStyles } from '@mui/material';
import { AppBar, useRecordContext } from 'react-admin'
// import BackButton from './backButton'
import { List, ListButton, TopToolbar, Pagination,  Create, SimpleForm, TextInput, email, BooleanField,Link, Button, SelectInput, Datagrid, TextField, ReferenceField, EditButton, DeleteButton, ShowButton, DateField } from 'react-admin';

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ permissions, basePath, data, resource }) => (
    <TopToolbar>
        <ListButton basePath="settings" />
    </TopToolbar>
)

const SettingValue = () => {
    const record = useRecordContext();
    let recordValue = record.setting_value[1].toLowerCase() === 'true' ? 'ON' : 'OFF';
    return recordValue;
}


export const SettingChangeLogList = ({ permissions, ...props }) => {
    console.log('SettingChangeLogList===================')
    return (
        <Scrollbars class="scroll-container">
            {/* <BackButton/> */}
            <List title="User logs" actions={<EditActions/>}  {...props}   bulkActionButtons={false}  >
                <Datagrid  bulkActionButtons={false} >
                    <TextField source="updated_by" sortable={false} />
                    <DateField label="Updated date" source="updated_at" showTime />
                    <TextField source="setting_name" label="Setting Name"  sortable={false}/>
                    <SettingValue source="setting_value[1]" label="Setting Value" sortable={false} />
                    {/* <TextField source="email" />
                    <StatusField source="status" />
                    <TextField source="userRole" /> */}
                </Datagrid>
            </List>
        </Scrollbars>
    )
}

